module.exports = __webpack_public_path__ + "static/media/S3N4-2.6ba58b5b.svg";